import { render, staticRenderFns } from "./DAdminSettingSwitcher.vue?vue&type=template&id=bae166c4&"
import script from "./DAdminSettingSwitcher.vue?vue&type=script&lang=js&"
export * from "./DAdminSettingSwitcher.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports